import Button from '@ramsey-design-system/button';
import { ArrowRightIcon } from '@ramsey-design-system/icons';

function StandardNextButton() {
  return (
    <Button
      data-testid="standard_next_button"
      type="submit"
      icon={ArrowRightIcon}
      iconPosition="right"
      className={'!w-full'}
      fullWidthOnMobile={true}
      size="large"
    >
      Next
    </Button>
  );
}

export { StandardNextButton };
